import {
    ADD_FAVOURITE_PRODUCT_SUCCESS,
    FETCH_ALL_PRODUCT_SUCCESS,
    FETCH_PRODUCT_SUCCESS,
    FILTER_PRODUCT,
    GET_ALL_PRODUCT,
    GET_UNSELECTED_ALL_PRODUCT,
    HANDLE_PRODUCT_REQUEST_CLOSE,
    HIDE_PRODUCT_LOADER,
    SHOW_PRODUCT_LOADER,
    ON_ADD_PRODUCT,
    ON_EDIT_PRODUCT,
    ON_ALL_PRODUCT_SELECT,
    ON_PRODUCT_CLOSE,
    ON_PRODUCT_SELECT,
    ON_DELETE_PRODUCT_SUCCESS,
    ON_FILTER_SELECTED_PRODUCT,
    ON_FILTER_PRODUCT_OPTION_SELECT,
    ON_SAVE_PRODUCT_SUCCESS,
    ON_TOGGLE_PRODUCT_DRAWER,
    SHOW_PRODUCT_MESSAGE,
    UPDATE_SEARCH_PRODUCT,
    SET_PRODUCT,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
    ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All products';
export const STARRED_FILTER = 'Starred products';
export const SUCCESSFUL_UPDATE = 'Product Updated Successfully';
export const SUCCESSFUL_FILTER = 'Product Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Product Deleted Successfully';
export const REMOVED_AS_STAR = 'Product removed as star';
export const MARKED_AS_STAR = 'Product marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No products found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allProduct: [],
    productList: [],
    selectedProduct: null,
    selectedProducts: 0,
    addProductState: false,
    editProductState: false,
    searchProduct: '',
    valueStreamSelectionList: [],
    selectedValueStreams: 0,
    product: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedProduct: null,
            };
        }
        case ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS: {
            return {
                ...state,
                valueStreamSelectionList: action?.payload,
                loader: false,
            };
        }
        case SET_PRODUCT: {
            const products = state.allProduct.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedProduct: products?.length > 0 ? products[0] : [],
            };
        }
        case ADD_FAVOURITE_PRODUCT_SUCCESS: {
            const allUpdated = state.allProduct.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                productList: listUpdated,
                allProduct: allUpdated,
            };
        }
        case FETCH_PRODUCT_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProduct: action.payload,
                addProductState: false,
                editProductState: false,
            };
        }
        case FETCH_ALL_PRODUCT_SUCCESS: {
            return {
                ...state,
                loader: false,
                allProduct: action.payload,
                productList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addProductState: false,
                editProductState: false,
            };
        }
        case SHOW_PRODUCT_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_PRODUCT_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedValueStreams = 0;
            const valueStreamSelectionList = state.valueStreamSelectionList.map(valueStream => {
                if (valueStream.selected) {
                    selectedValueStreams++;
                }
                if (valueStream.id === action.payload.id) {
                    if (valueStream.selected) {
                        selectedValueStreams++;
                    }
                    return action.payload;
                } else {
                    return valueStream;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedValueStreams: selectedValueStreams,
                valueStreamSelectionList: valueStreamSelectionList
            };
        }
        case ON_ADD_PRODUCT: {
            return {
                ...state,
                addProductState: true,
                editProductState: false,
            };
        }
        case ON_EDIT_PRODUCT: {
            return {
                ...state,
                selectedProduct: action.payload,
                editProductState: true,
                addProductState: false,
            };
        }
        case ON_PRODUCT_CLOSE: {
            return {
                ...state,
                addProductState: false,
                editProductState: false,
            };
        }
        case ON_FILTER_PRODUCT_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let productList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    productList = state.allProduct;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    productList = state.allProduct.filter((product) => product.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, productList, drawerState: false
            };
        }
        case ON_SAVE_PRODUCT_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                productList: addOrUpdateEntry(state.productList, action.payload),
                allProduct: addOrUpdateEntry(state.allProduct, action.payload),
                selectedProduct: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_PRODUCT_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allProduct: state.allProduct.filter((product) => product.id !== action.payload),
                productList: state.allProduct.filter((product) => product.id !== action.payload),
                selectedProduct: null,
            };
        }
        case ON_FILTER_SELECTED_PRODUCT: {
            const products = state.allProduct.filter((product) => !product.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                productList: products,
                selectedProducts: 0
            };
        }
        case FILTER_PRODUCT: {
            const { filterOption } = state;
            let productList = [];
            if (action.payload === '') {
                productList = state.allProduct;
            } else {
                const filterProduct = state.allProduct.filter((product) =>
                    product.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    productList = filterProduct;
                } else if (filterOption === STARRED_FILTER) {
                    productList = filterProduct.filter((product) => product.starred);
                }
            }
            return { ...state, productList: productList };
        }
        case GET_ALL_PRODUCT: {
            let productList = state.allProduct.map((product) => product ? {
                ...product,
                selected: true
            } : product);
            return {
                ...state,
                selectedProducts: productList.length,
                allProduct: productList,
                productList: productList
            };
        }
        case GET_UNSELECTED_ALL_PRODUCT: {
            let productList = state.allProduct.map((product) => product ? {
                ...product,
                selected: false
            } : product);
            return {
                ...state,
                selectedProducts: 0,
                allProduct: productList,
                productList: productList
            };
        }
        case ON_ALL_PRODUCT_SELECT: {
            const selectAll = state.selectedProducts < state.productList.length;
            let selectedProducts = 0;
            let productList = [];
            if (selectAll) {
                productList = state.allProduct.map((product) => product ? {
                    ...product,
                    selected: true
                } : product);
                selectedProducts = productList.length;
            } else {
                productList = state.allProduct.map((product) => product ? {
                    ...product,
                    selected: true
                } : product);
                selectedProducts = 0;
            }
            return {
                ...state,
                selectedProducts: selectedProducts,
                allProduct: productList,
                productList: productList
            };
        }
        case UPDATE_SEARCH_PRODUCT: {
            return { ...state, searchProduct: action.payload };
        }
        case HANDLE_PRODUCT_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PRODUCT_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PRODUCT_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PRODUCT_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/product.js